var _path, _path2, _path3, _path4, _path5, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChallengesub2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 85,
    viewBox: "0 0 83 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3951 33.818C28.6961 33.818 33.8041 28.71 33.8041 22.409C33.8041 16.108 28.6961 11 22.3951 11C16.0941 11 10.9861 16.108 10.9861 22.409C10.9861 28.71 16.0941 33.818 22.3951 33.818Z",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6073 39.9029C33.8043 35.7196 28.4801 33.4378 22.3953 33.4378C11.3666 33.4378 3 41.4241 3 53.2134V61.58H30.7619",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0303 36.4802L58.1438 30.3954L75.2573 36.4802V51.3119C75.2573 63.4815 68.4119 72.2284 58.1438 77.5526C47.8757 72.2284 41.0303 63.4815 41.0303 51.3119V36.4802Z",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1432 39.9028L66.5098 42.9452V51.3118C66.5098 57.3966 63.4674 62.3405 58.1432 65.7632C52.819 62.3405 49.7766 57.3966 49.7766 51.3118V42.9452L58.1432 39.9028Z",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7207 52.0725L57.3828 54.7346L62.3267 48.2695",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.82843,
    y1: 2,
    x2: 81,
    y2: 80.1716,
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 112.551,
    y2: -2,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 0 83)",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengesub2);
export default __webpack_public_path__ + "static/media/challengesub2.63986837860c34bd5d9961c6a2a10788.svg";
export { ForwardRef as ReactComponent };